import { MapPin, BadgeCheck, Clock, Radius } from "lucide-react";

export const DriverCard = ({ driver, onRequest }) => (
  <div data-testid={`driver-card-${driver.id}`} className="bg-white border border-rr-line rounded-2xl p-6 hover:border-rr-orange hover:shadow-lg transition-all">
    <div className="flex items-start justify-between gap-3">
      <div>
        <h3 data-testid={`driver-card-name-${driver.id}`} className="font-heading text-lg font-bold text-rr-navy">{driver.name}</h3>
        <p className="text-xs text-rr-muted flex items-center gap-1 mt-1">
          <MapPin size={12} /> {[driver.city, driver.state].filter(Boolean).join(", ") || "Location on request"}
        </p>
      </div>
      <span
        data-testid={`driver-card-availability-${driver.id}`}
        className={`text-xs font-bold px-2.5 py-1 rounded-full shrink-0 ${
          driver.availability === "available" ? "bg-rr-green/10 text-rr-green" : "bg-rr-muted/10 text-rr-muted"
        }`}
      >
        {driver.availability === "available" ? "Available" : "Unavailable"}
      </span>
    </div>

    <div className="flex flex-wrap items-center gap-3 mt-4 text-xs font-semibold text-rr-muted">
      {driver.cdl_class && (
        <span className="inline-flex items-center gap-1"><BadgeCheck size={13} className="text-rr-orange" /> CDL {driver.cdl_class}</span>
      )}
      {driver.experience_years != null && (
        <span className="inline-flex items-center gap-1"><Clock size={13} className="text-rr-orange" /> {driver.experience_years} yrs exp.</span>
      )}
      {driver.service_radius_miles && (
        <span className="inline-flex items-center gap-1"><Radius size={13} className="text-rr-orange" /> {driver.service_radius_miles} mi radius</span>
      )}
    </div>

    {driver.trailer_types?.length > 0 && (
      <div className="flex flex-wrap gap-1.5 mt-3">
        {driver.trailer_types.map((t) => (
          <span key={t} className="text-[11px] font-bold px-2.5 py-1 rounded-full bg-rr-navy/5 text-rr-navy">{t}</span>
        ))}
      </div>
    )}
    {driver.endorsements?.length > 0 && (
      <div className="flex flex-wrap gap-1.5 mt-1.5">
        {driver.endorsements.map((e) => (
          <span key={e} className="text-[11px] font-bold px-2.5 py-1 rounded-full bg-rr-orange/10 text-rr-orange">{e}</span>
        ))}
      </div>
    )}

    <button
      onClick={() => onRequest(driver)}
      data-testid={`driver-card-request-button-${driver.id}`}
      className="w-full mt-5 bg-rr-navy text-white font-bold text-sm py-2.5 rounded-full hover:bg-rr-orange transition-colors"
    >
      Request This Driver
    </button>
  </div>
);
